import { motion } from "framer-motion";
import { imgSet } from "../lib/api";

export const Reveal = ({ children, delay = 0, className = "", as = "div", ...rest }) => {
  const Tag = motion[as] || motion.div;
  return (
    <Tag
      className={className}
      initial={{ opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
      {...rest}
    >
      {children}
    </Tag>
  );
};

export const ImageReveal = ({ src, alt, className = "", imgClassName = "" }) => (
  <motion.div className={`relative overflow-hidden ${className}`} initial="hidden" whileInView="show" viewport={{ once: true, margin: "-60px" }}>
    <motion.img
      {...imgSet(src, "(max-width: 1024px) 100vw, 50vw")}
      alt={alt}
      width="1264"
      height="848"
      loading="lazy"
      decoding="async"
      className={`h-full w-full object-cover ${imgClassName}`}
      variants={{ hidden: { scale: 1.12, opacity: 0.4 }, show: { scale: 1, opacity: 1 } }}
      transition={{ duration: 1.3, ease: [0.22, 1, 0.36, 1] }}
    />
    <motion.div
      className="absolute inset-0 bg-ivory origin-right"
      variants={{ hidden: { scaleX: 1 }, show: { scaleX: 0 } }}
      transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
    />
  </motion.div>
);

export const SectionHead = ({ eyebrow, title, text, align = "left", dark = false, testId }) => (
  <Reveal className={`max-w-2xl ${align === "center" ? "mx-auto text-center" : ""}`}>
    {eyebrow && <p className="eyebrow mb-4" data-testid={testId ? `${testId}-eyebrow` : undefined}>{eyebrow}</p>}
    <h2 className={`h2 ${dark ? "!text-ivory" : ""}`} data-testid={testId ? `${testId}-title` : undefined}>{title}</h2>
    <div className={`hairline mt-6 ${align === "center" ? "mx-auto" : ""}`} />
    {text && <p className={`lead mt-6 ${dark ? "!text-ivory/75" : ""}`}>{text}</p>}
  </Reveal>
);

export const Monogram = ({ light = false, size = "md" }) => {
  const s = size === "sm" ? "h-9 w-9 text-sm" : "h-11 w-11 text-base";
  return (
    <span className={`inline-flex ${s} items-center justify-center border font-serif font-semibold tracking-tight ${light ? "border-gold text-gold" : "border-emerald-800 text-emerald-800"}`}>
      M&S
    </span>
  );
};

const STATUS_STYLES = {
  proposed: "bg-ivory-200 text-charcoal/70 border-charcoal/10",
  planned: "bg-gold-100 text-gold-600 border-gold/40",
  approved: "bg-emerald-100 text-emerald-700 border-emerald-600/30",
};
export const StatusBadge = ({ status = "proposed" }) => (
  <span className={`inline-block rounded-full border px-2.5 py-0.5 text-[10px] font-medium uppercase tracking-[0.18em] ${STATUS_STYLES[status] || STATUS_STYLES.proposed}`} data-testid={`status-badge-${status}`}>
    {status}
  </span>
);
